import { slice } from '../slices/deepSearch';

const nameSpace = slice.name;

export const isLoading = (state) => state[nameSpace].isLoading;
export const targetTagId = (state) => state[nameSpace].targetTagId;
export const filterBy = (state) => state[nameSpace].filterBy;
export const selectedItemId = (state) => state[nameSpace].selectedItemId;
export const isIncludeAllTags = (state) => state[nameSpace].isIncludeAllTags;
export const data = (state) => state[nameSpace].data;
export const describe = (state) => state[nameSpace].describe;
export const deepQuery = (state) => state[nameSpace].deepQuery;
export const deepSearchTabIsAvailable = (state) => state[nameSpace].deepSearchTabIsAvailable;
export const videoTags = (state) => state[nameSpace].videoTags;
